import { ReactNode } from 'react'

import { TokenBalance, TokenDisplay } from '~/components/component-library'
import { SupportedChainId } from '~/constants/chains'
import { IAddress } from '~/types'
import { cn } from '~/utils/tailwind-utils'

export const TokenSelectorOption = ({
  token,
  chainId,
  balance,
  onSelect,
  selected,
  className,
  displayZeroBalance = false,
  hideBalance = false,
  isRelayNetwork = false,
  protocol,
  suffix,
}: {
  token: IAddress
  chainId: SupportedChainId
  balance: bigint | undefined
  onSelect?: () => void
  selected?: boolean
  className?: string
  displayZeroBalance?: boolean
  hideBalance?: boolean
  isRelayNetwork?: boolean
  protocol?: string
  suffix?: ReactNode
}) => {
  return (
    <div
      data-testid="token-selector-option"
      className={cn(
        'flex w-full items-start justify-between gap-3 rounded-lg px-3 py-2',
        {
          'bg-gray-100 dark:bg-gray-900': selected,
          'cursor-pointer md:hover:bg-gray-100 md:dark:hover:bg-gray-900':
            selected !== undefined,
        },
        className,
      )}
      onClick={onSelect}
    >
      <div className="min-w-0 flex-1">
        <TokenDisplay
          address={token}
          chainId={chainId}
          layout="two-line"
          size="small"
          hideInactiveChainIndicator={isRelayNetwork}
          protocol={protocol}
          suffix={suffix}
        />
      </div>
      {(displayZeroBalance || balance) && !hideBalance ? (
        <div className="flex-shrink-0 text-right">
          <TokenBalance
            address={token}
            chainId={chainId}
            tokenAmount={balance ?? 0n}
            layout="standard"
            size="small"
            direction="neutral"
          />
        </div>
      ) : null}
    </div>
  )
}
